<template>
    <div class="apply-page-container">
        <!-- loading -->
        <div v-if="isLoading" class="loading-container">
            <DotFadeSpinner />
            <div class="loading-message">심사중입니다..</div>
        </div>

        <!-- results -->
        <div v-else class="apply-page">
            <div class="section-one">
                <div class="title-box">
                    <img class="icon" :src="require(`@/assets/images/icons/clap.svg`)" />
                    <div class="title">환영합니다</div>
                </div>
                <div class="sub-title">
                    <p>{{ me.name }}님은 가입 심사에</p>
                    <p><span class="highlight">'합격'</span> 하셨습니다.</p>
                </div>

                <div class="desc">
                    매칭률은
                    <span class="highlight-box" :class="`color-${resultNumber}`">
                        <img class="icon" :src="require(`@/assets/images/icons/hand.svg`)" />'{{
                            getWord(resultNumber)
                        }}' </span
                    >으로 예상됩니다.
                </div>
            </div>

            <!-- <div v-if="version === 0" class="section-two">
                <div>🚨 곧 사라지는 혜택 🚨</div>

                <div>41분 46초 남음</div>

                <div>
                    1시간 이내에 프로필 작성을 완료하면<br />
                    매칭률이 훨씬 높은 프로페셔널 매니저를<br />
                    무료로 배정해드려요!
                </div>
            </div>
            <div v-if="version === 1" class="section-two">
                <div>🚨 곧 사라지는 혜택 🚨</div>

                <div>41분 46초 남음</div>

                <div>
                    1시간 이내에 프로필 작성을 완료하면<br />
                    매칭률이 훨씬 높은 프로페셔널 매니저를<br />
                    무료로 배정해드려요!
                </div>
            </div> -->

            <div class="section-three">
                <button class="btn" @click="goNextPage">
                    <p class="label f-regular">인증하고 프로필 받기</p>
                </button>
                <div class="btn-desc">
                    <img class="icon" :src="require(`@/assets/images/icons/alarm-clock.svg`)" />
                    3분 소요
                </div>
                <div class="desc">
                    현재는 <span class="highlight">‘준회원'</span> 상태이며, 나머지 프로필을 완성하면<br />
                    최종 가입 심사 후 매니저를 배정해드려요
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import userService from '@/services/user'
import { sendMetaTransition } from '@/services/meta-event'

export default {
    name: 'ApplyResultPage',
    components: {},
    data: () => ({
        version: 0,
        isLoading: true,
        isPassedTwoSeconds: false,
        resultNumber: null,
        _ran: false,
    }),
    computed: {
        me() {
            return this.$store.getters.me
        },
        profile() {
            return this.$store.getters.profile
        },
    },
    methods: {
        goNextPage() {
            this.$router.push({ name: 'ChatsPage' })
        },
        getWord(val) {
            if (val === 5) {
                return '매우 높음'
            } else if (val === 4) {
                return '높음'
            } else if (val === 3) {
                return '평균'
            } else {
                return '불합격'
            }
        },
        async handleAfterLoading() {
            // console.log('1.5초 후 실행될 이벤트 발생!')
            // 여기에 원하는 로직 추가

            const lookScoreSelf = this.profile.look_score_self
            const income = this.profile.income

            // 'very_high': 5, 'high': 4, 'avg': 3, 'failed': -1 이렇게 4개 값
            let result = -1

            if (this.me.gender === 0) {
                // 남자
                if (lookScoreSelf >= 80) {
                    result = 5
                } else if (lookScoreSelf >= 50) {
                    if (income >= 6000) {
                        result = 5
                    } else {
                        result = 4
                    }
                } else if (lookScoreSelf >= 30) {
                    if (income >= 6000) {
                        result = 3
                    } else {
                        result = -1
                    }
                } else {
                    if (income >= 6000) {
                        result = 3
                    } else {
                        result = -1
                    }
                }
            } else {
                // 여자
                if (lookScoreSelf >= 50) {
                    result = 5
                } else if (lookScoreSelf >= 30) {
                    result = 4
                } else {
                    result = -1
                }
            }
            this.resultNumber = result

            if (result >= 3) {
                // 합격 처리
                const payload = {
                    user_id: this.me.id,
                    status: 'success',
                }
                const res = await userService.profilePreJudgement(payload)
                if (res && res.res === 'success' && this.isPassedTwoSeconds) {
                    this.isLoading = false
                }
            } else if (result === -1) {
                // 불합격 처리
                const payload = {
                    user_id: this.me.id,
                    status: 'fail',
                }
                const res = await userService.profilePreJudgement(payload)
                if (res && res.res === 'success') {
                    const idx = this.$modal.basic({
                        title: '프로필 심사중',
                        body:
                            '심사 요청이 완료되었습니다. 심사 결과는 패스하신 경우에만 연락드리며, 패스하지 못한 경우 입력하신 모든 개인정보는 안전하게 파기되오니 안심하셔도 좋습니다.<br/>(패스하지 못한 경우 재신청이 가능합니다.)',
                        buttons: [
                            {
                                label: 'CANCEL',
                                class: 'btn-default',
                            },
                            {
                                label: 'CONFIRM',
                                class: 'btn-primary',
                            },
                        ],
                    })
                    if (idx) {
                        // 로그 아웃 후 홈으로
                        this.$store.dispatch('signOut')
                        this.$router.push({ name: 'HomePage' })
                    }
                }
            }
        },
        tryRunAfterLoading() {
            if (
                this.me &&
                this.profile &&
                this.me.gender !== undefined &&
                this.profile.look_score_self !== undefined &&
                !this._ran
            ) {
                this._ran = true
                this.handleAfterLoading()
                // setTimeout(() => {
                //     this.isLoading = false
                //     this.handleAfterLoading()
                // }, 1500)
            }
        },
    },
    mounted() {
        this.$fbPixel.track('Schedule')
        sendMetaTransition('Schedule')

        setTimeout(() => {
            if (this.profile) {
                // this.handleAfterLoading()
                this.isPassedTwoSeconds = true
                if (this.resultNumber >= 3) {
                    this.isLoading = false
                }
            }
        }, 2000)

        // 심사 처리하기
    },
    watch: {
        me: {
            handler(newVal) {
                if (newVal && newVal.gender !== undefined) {
                    console.log('me 들어왔음:', newVal)
                    this.tryRunAfterLoading()
                }
            },
            immediate: true,
            deep: true,
        },
        profile: {
            handler(newVal) {
                if (newVal && newVal.look_score_self !== undefined) {
                    console.log('profile 들어왔음:', newVal)
                    this.tryRunAfterLoading()
                }
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.loading-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .loading-message {
        margin-top: 16px;
        color: black;
        font-size: 14px;
    }
}

.apply-page {
    padding-left: 20px;
    padding-right: 20px;
}
.section-one {
    margin: calc(150px - 56px) 0 70px 29px;
    text-align: left;

    .title-box {
        // margin-bottom: 35px;
        margin-bottom: 9px;

        .icon {
            margin-bottom: 12px;
            width: 30px;
            height: 30px;
            flex-shrink: 0;
            aspect-ratio: 1/1;
        }

        .title {
            // color: #070555;
            // // text-align: center;
            // font-feature-settings: 'liga' off, 'clig' off;
            // font-family: 'Gowun Dodum';
            // font-size: 28px;
            // font-style: normal;
            // font-weight: 400;
            // line-height: 150%; /* 42px */

            color: var(--Deep-Purple, #181f39);
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%; /* 20px */
        }
    }

    .sub-title {
        margin-bottom: 44px;

        // color: var(--Deep-Purple, #181f39);
        // font-feature-settings: 'liga' off, 'clig' off;
        // font-family: Pretendard;
        // font-size: 17px;
        // font-style: normal;
        // font-weight: 600;
        // line-height: 100%; /* 17px */

        color: var(--Deep-Purple, #181f39);
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 100%; /* 20px */

        > p:first-child {
            margin-bottom: 9px;
        }

        .highlight {
            color: #0a7;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%; /* 20px */

            // display: inline-block;
            // padding: 5px 8px;
            // justify-content: center;
            // align-items: center;
            // gap: 10px;

            // border-radius: 5px;
            // background: #0a7;

            // color: #fff;
            // font-feature-settings: 'liga' off, 'clig' off;
            // font-family: Pretendard;
            // font-size: 17px;
            // font-style: normal;
            // font-weight: 600;
            // line-height: 100%; /* 17px */
        }
    }

    .desc {
        display: flex;
        justify-content: start;
        align-items: center;
        gap: 3px;

        color: var(--Grey-787878, #787878);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 21px */

        .highlight-box {
            display: flex;
            padding: 3px 5px;
            justify-content: center;
            align-items: center;
            gap: 3px;

            border-radius: 5px;
            background: #f1f1f1;

            color: #3452d5;
            text-align: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%; /* 21px */

            &.color-5 {
                color: #3452d5;
            }
            &.color-4 {
                color: #34bdd5;
            }
            &.color-3 {
                color: #4c4d51;
            }
            &.color--1 {
                color: #ff7d37;
            }
        }
    }
}

.section-two {
    background-color: lightgray;
    padding: 5px;
}

.section-three {
    button {
        height: 52px;
        width: 100%;
        font-size: 15px;
        background: $blue-primary;
        color: white;
        border-radius: 32px;
        border-width: 0;
        @include spoqa-f-medium;

        margin: 0 0 10px 0;

        p {
            color: #fdfcfa;
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 17px;
            font-style: normal;
            font-weight: 600;
            line-height: 100%;
        }
    }

    .btn-desc {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        margin-bottom: 18px;

        color: #3452d5;
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 16.5px */

        img {
            width: 15px;
            height: 15px;
            flex-shrink: 0;
            aspect-ratio: 1/1;
        }
    }

    .desc {
        color: var(--Grey-787878, #787878);
        text-align: center;
        font-feature-settings: 'liga' off, 'clig' off;
        font-family: Pretendard;
        font-size: 11px;
        font-style: normal;
        font-weight: 300;
        line-height: 150%; /* 16.5px */

        .highlight {
            color: var(--Grey-787878, #787878);
            font-feature-settings: 'liga' off, 'clig' off;
            font-family: Pretendard;
            font-size: 11px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%;
        }
    }
}
</style>
